import axios from 'axios';

const getListingChannelId = async (
  userId: string,
  listingId: string,
): Promise<string> => {
  try {
    const url = '/streamchat/getListingChannelId';

    const { data } = await axios.get<string>(url, {
      params: { userId, listingId },
    });

    return data;
  } catch (error) {
    console.error('Error fetching Stream Chat Listing Channel ID:', error);
  }
};

export default getListingChannelId;
